module.exports = __webpack_public_path__ + "media/images/logo/kaufland-4f19e4377208081dc4581fd6eee20a3c.png";